// ForecastSummaryStyle.ts

export const forecastSummaryMerges = [
  { row: 0, col: 1, rowspan: 1, colspan: 13 }, // B1:N1
  { row: 1, col: 1, rowspan: 1, colspan: 13 }, // B2:N2
  { row: 2, col: 1, rowspan: 1, colspan: 13 }, // B3:N3
  { row: 3, col: 1, rowspan: 1, colspan: 13 }, // B4:N4
  { row: 4, col: 1, rowspan: 1, colspan: 13 }, // B5:N5
  { row: 6, col: 2, rowspan: 1, colspan: 2 }, // C7:D7
  { row: 8, col: 2, rowspan: 1, colspan: 2 }, // C9:D9
  { row: 10, col: 2, rowspan: 1, colspan: 2 }, // C11:D11
  { row: 12, col: 2, rowspan: 1, colspan: 2 }, // C13:D13
  { row: 14, col: 2, rowspan: 1, colspan: 2 }, // C15:D15
  { row: 16, col: 2, rowspan: 1, colspan: 2 }, // C17:D17
  { row: 18, col: 2, rowspan: 1, colspan: 2 }, // C19:D19
  { row: 19, col: 1, rowspan: 1, colspan: 13 }, // B20:N20
  { row: 39, col: 1, rowspan: 1, colspan: 13 }, // B40:N40
  { row: 40, col: 1, rowspan: 1, colspan: 13 }, // B41:N41
  { row: 41, col: 1, rowspan: 1, colspan: 13 }, // B42:N42
  { row: 42, col: 1, rowspan: 1, colspan: 13 }, // B43:N43
  { row: 21, col: 5, rowspan: 1, colspan: 2 }, // F22:G22
  { row: 21, col: 7, rowspan: 1, colspan: 2 }, // H22:I22
  { row: 21, col: 10, rowspan: 1, colspan: 2 }, // K22:L22
  { row: 21, col: 12, rowspan: 1, colspan: 2 }, // M22:N22
];

export const forecastSummaryColWidths = (index: number): number => {
  // Add any custom widths here if needed
  return 100;
};

export function getForecastSummaryCellClassNames(row: number, col: number): string[] {
  const classNames: string[] = [];
  // B1:N1 merged cell dark grey with white text
  if (row === 0 && col >= 1 && col <= 13) {
    classNames.push('dark-grey-bg', 'white-text');
  }
  // Column A (col 0) grey background
  if (col === 0) {
    classNames.push('grey-bg');
  }
  // B5:N5 black bottom border
  if (row === 4 && col >= 1 && col <= 13) {
    classNames.push('black-bottom-border');
  }
  // B20:N20 black bottom border
  if (row === 19 && col >= 1 && col <= 13) {
    classNames.push('black-bottom-border');
  }
  // E7, E9, E11, E13, E15, E17, E19 full black border
  if ([6,8,10,12,14,16,18].includes(row) && col === 4) {
    classNames.push('black-full-border');
  }
  // H7 (row 6, col 7) border all sides
  if (row === 6 && col === 7) {
    classNames.push('border-all-h7');
  }
  // O1 to AS300 (col 14 to 45, row 0 to 299) grey background
  if (row >= 0 && row < 300 && col >= 14 && col <= 45) {
    classNames.push('grey-bg');
  }
  return classNames;
} 